import React from 'react';
import {
  PlusCircle as Add,
  Edit,
  MessageCircle,
  Trash as Remove
} from 'lucide-react';
import * as translations from './strings';
import { ARCHIVE_ALL_MENU_KEY } from './types';
import ArchiveAll from './ArchiveAll';
import { getLangKey } from 'jsModels/Application';
import styles from './index.module.css';

const strings = translations[getLangKey()];

type Handler = () => void;

type Props = {
  handlers: Handler[];
  archiveStage: string;
  cards: any[];
  archiveAllowed: boolean;
  unreadCommentsAllowed: boolean;
  archiveDisabled: boolean;
  deleteProps: {
    title?: string;
    disabled: boolean;
  };
};

export const items = ({
  handlers,
  archiveStage,
  cards,
  archiveAllowed,
  unreadCommentsAllowed,
  archiveDisabled,
  deleteProps
}: Props): {
  key: string;
  label: string | undefined;
  icon: React.ReactNode;
  onClick: Handler;
  hide?: boolean;
  disabled?: boolean;
  title?: string;
}[] => [
  {
    key: 'add_task',
    label: strings.addTask,
    icon: <Add className={styles.actionIcon} />,
    onClick: handlers[0]
  },
  {
    key: 'add_column',
    label: strings.addColumn,
    icon: <Add className={styles.actionIcon} />,
    onClick: handlers[1]
  },
  {
    key: 'rename_column',
    label: strings.renameColumn,
    icon: <Edit className={styles.actionIcon} />,
    onClick: handlers[2]
  },
  {
    key: 'mark_all_as_read',
    label: strings.markAllAsRead,
    icon: <MessageCircle />,
    onClick: handlers[3],
    hide: !unreadCommentsAllowed
  },
  {
    key: ARCHIVE_ALL_MENU_KEY,
    label: undefined,
    icon: <ArchiveAll stage={archiveStage} taskCount={cards.length} />,
    onClick: handlers[4],
    hide: !archiveAllowed,
    disabled: archiveDisabled
  },
  {
    key: 'delete_column',
    label: strings.deleteColumn,
    icon: <Remove className={styles.actionIcon} />,
    onClick: handlers[5],
    ...deleteProps
  }
];
